export default "__VITE_PUBLIC_ASSET__ef719462__"